const GIFT_TIERS = [
  {
    minTotal: 120,
    variantId: 56026185007488
  },
  {
    minTotal: 40,
    variantId: 56020418298240
  }
];

const DEFAULT_GIFT_SECTIONS = ['main-cart', 'cart-drawer', 'cart-bubble'];

function getEligibleGiftVariantIds(cartTotal) {
  const eligibleIds = [];
  // Sortiere nach minTotal (absteigend), damit niedrigere Stufen auch erfasst werden
  const sortedTiers = [...GIFT_TIERS].sort((a, b) => b.minTotal - a.minTotal);
  
  for (const tier of sortedTiers) {
    if (cartTotal >= tier.minTotal) {
      eligibleIds.push(tier.variantId);
    }
  }
  
  return eligibleIds;
}

function isManagedGiftLine(item) {
  if (!item) return false;

  const properties = item.properties || {};
  return properties._is_gift === true || properties._is_gift === 'true' || !!properties._gift_token;
}

function normalizeSections(sections = DEFAULT_GIFT_SECTIONS) {
  if (!Array.isArray(sections) || sections.length === 0) {
    return [...DEFAULT_GIFT_SECTIONS];
  }

  return [...new Set(sections)];
}

function isValidCartState(cart) {
  return !!cart && Array.isArray(cart.items) && typeof cart.total_price === 'number';
}

async function fetchCartState() {
  const response = await fetch('/cart.js', {
    headers: {
      'Accept': 'application/json'
    }
  });

  return await response.json();
}

function hasAnyGift(cart) {
  if (!cart || !cart.items) return false;
  return cart.items.some((item) => isManagedGiftLine(item));
}

async function syncGiftLinesInCart(cart, desiredVariantIds = [], sections = DEFAULT_GIFT_SECTIONS) {
  if (!cart || !cart.items || cart.items.length === 0) {
    return {
      state: null,
      hasAllDesiredGifts: false
    };
  }

  const updates = {};
  const desiredIdSet = new Set(desiredVariantIds);
  const foundGiftVariants = new Set();

  // Durchlaufe alle Cart-Items und markiere nicht-gewünschte Geschenke zum Löschen
  for (const item of cart.items) {
    if (!isManagedGiftLine(item)) {
      continue;
    }

    const isDesiredGift = desiredIdSet.has(item.variant_id);

    if (!isDesiredGift) {
      // Nicht qualifizierendes Geschenk entfernen
      updates[item.key] = 0;
      continue;
    }

    // Gewünschtes Geschenk behalten/aktualisieren
    foundGiftVariants.add(item.variant_id);

    if (item.quantity !== 1) {
      updates[item.key] = 1;
    }
  }

  // Bestimme, welche neuen Geschenke hinzugefügt werden müssen
  const giftIdsToAdd = desiredVariantIds.filter(id => !foundGiftVariants.has(id));

  // Wenn keine Updates und keine neuen Gifts -> early return
  if (Object.keys(updates).length === 0 && giftIdsToAdd.length === 0) {
    return {
      state: null,
      hasAllDesiredGifts: foundGiftVariants.size === desiredVariantIds.length
    };
  }

  let state = null;

  // Schritt 1: Bestehende Items aktualisieren/entfernen
  if (Object.keys(updates).length > 0) {
    const payload = {
      updates,
      sections,
      sections_url: window.location.pathname
    };

    try {
      const response = await fetch(theme.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      state = await response.json();
    } catch (error) {
      console.error('Fehler beim Synchronisieren der Geschenke mit cart/update:', error);
    }
  }

  // Schritt 2: Neue Geschenke hinzufügen
  for (const giftVariantId of giftIdsToAdd) {
    const addState = await addGiftToCart(giftVariantId, sections);
    if (addState && typeof addState === 'object') {
      state = addState;
    }
  }

  return {
    state,
    hasAllDesiredGifts: foundGiftVariants.size + giftIdsToAdd.length === desiredVariantIds.length
  };
}

async function addGiftToCart(giftVariantId, sections = DEFAULT_GIFT_SECTIONS) {
  const formData = new FormData();
  formData.append('id', giftVariantId);
  formData.append('quantity', 1);
  formData.append('sections', sections);
  formData.append('sections_url', window.location.pathname);
  formData.append('properties[_is_gift]', 'true');
  formData.append('properties[_gift_token]', Date.now().toString());

  const response = await fetch(theme.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/javascript'
    },
    body: formData
  });

  try {
    return await response.json();
  } catch (error) {
    console.error('Fehler beim Hinzufügen des Geschenks zum Warenkorb:', error);
  }
  
  return null;
}

async function handleGiftLogic(sections = DEFAULT_GIFT_SECTIONS, cartSnapshot = null) {
  sections = normalizeSections(sections);

  try {
    const cart = isValidCartState(cartSnapshot) ? cartSnapshot : await fetchCartState();
    const cartTotal = cart.total_price / 100;
    const eligibleGiftIds = getEligibleGiftVariantIds(cartTotal);

    // Keine Geschenke qualifizieren -> alle entfernen
    if (eligibleGiftIds.length === 0) {
      if (!hasAnyGift(cart)) {
        return null;
      }

      const { state } = await syncGiftLinesInCart(cart, [], sections);
      return state;
    }

    // Geschenke synchronisieren (behalte qualifizierende, entferne nicht-qualifizierende)
    const { state } = await syncGiftLinesInCart(cart, eligibleGiftIds, sections);

    return state;
  } catch (error) {
    console.error('Fehler bei Geschenklogik:', error);
  }

  return null;
}